import { createFileRoute } from "@tanstack/react-router";
import { PageSkeleton } from "@/components/PageSkeleton";
import Privacy from "@/pages/Privacy";
import { EMBED_BASE_URL } from "@/config/constants";

const TITLE = "Privacy Policy, EmbedKit";
const DESCRIPTION =
  "EmbedKit's privacy policy. We collect zero widget data, no cookies in embeds, no tracking of the values you enter.";
const URL = `${EMBED_BASE_URL}/privacy`;

export const Route = createFileRoute("/_dashboard/privacy")({
  component: Privacy,
  pendingComponent: PageSkeleton,
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: URL },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESCRIPTION },
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
});
